import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, useTheme, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SupplierForm from '../components/SupplierForm';
import { useGetSupplierHandler } from '../dataHandlers/getSupplierHandler';
import TopBar from '../../../components/TopBar';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export default function SupplierDetailsPage() {
  const { suppliers: s } = useTranslatedMessages();
  useDocumentTitle(s?.pages?.details?.document_title || 'Supplier Details');
  const theme = useTheme();
  const navigate = useNavigate();

  const { profile_id } = useParams();
  const { supplier, isLoading } = useGetSupplierHandler(profile_id);

  function onClickingBackButton() {
    return navigate('/suppliers');
  }

  if (isLoading || !supplier) return <DocumentSkeletonForm />;

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {supplier && (
        <Box sx={{ pb: 4 }}>
          <TopBar
            title={s?.pages?.details?.top_bar_title || 'Supplier Details'}
            subTitle={supplier?.profile_id}
            identifier={supplier?.profile_id}
          >
            <Button
              data-testid="supplier-profile-back-button"
              key="back"
              variant="contained"
              color="primary"
              onClick={onClickingBackButton}
              className="action-button"
              sx={{ marginLeft: theme.spacing(1) }}
            >
              {s?.pages?.details?.back || 'Back'}
            </Button>
          </TopBar>
        </Box>
      )}
      <SupplierForm initialData={supplier} readOnly={true} edit={false} />
    </Stack>
  );
}
